<template>
    <div class="materi-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-8 mb-5 mb-xl-0">
                    <router-view></router-view>
                </div>
                <div class="col-xl-4">
                    <div class="card" >
                        <div class="card-header row align-items-center bg-transparent">
                            <div class="d-flex justify-content-between" style="align-items: center;">
                                <div class="col">
                                    <h6 class="text-uppercase ls-1 mb-1">Info</h6>
                                </div>
                                <div >
                                    <b-dropdown id="dropdown-1" right text="Kembali" size="sm" class="m-md-2">
                                        <b-dropdown-item ><router-link :to="{ name: 'subject-detail', params:{ subjectId: overview.subjects_id} }" class="icon-clicked p-1"><i class="clr-red fa fa-arrow-left" aria-hidden="true"></i> Halaman Modul</router-link></b-dropdown-item>
                                    </b-dropdown>   
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="identity px-2">
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{overview.user_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-user" aria-hidden="true"></i>{{overview.user_status}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-book" aria-hidden="true"></i>{{overview.subject_name}}</p>
                                <p class="line-with-icon"><i class="clr-red fa fa-folder-open" aria-hidden="true"></i>{{overview.name}}</p>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="card">
                                <div class="card-body text-center">
                                    <h6>{{overview.total_task}}</h6>
                                    <h6>Total Penugasan</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        components: {
        },
        data() {
            return {
                modulId: this.$route.params.modulId,
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser',
                overview: 'getTaskOverview',
            })
        },
        methods: {
			async getTaskOverview() {
                let modulId = this.$route.params.modulId
				await this.$store.dispatch('getTaskOverview', { modulId })
					.then(() => {
					})
					.catch((err)=> {
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        created() {
            // this.setCurrentModulId(this.$route.params.modulId)
            // this.getTaskOverview()
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
</style>